// "Watch out for cheap replicas" popup (sections/replica-warning-modal.liquid) - global/site-wide
// so it works from any page, not just the ones that render the bundle builder. Triggers:
// [data-open-replica-warning-modal] (the comparison-card button in
// sections/quality-promise.liquid) or a plain `<a href="#open-replica-warning-modal">`
// (used inside FAQ answer rich text, which appears on many different templates).
//
// Delegated on `document` rather than binding directly to the trigger/close elements at script
// load time - this script has `defer`, but trigger/overlay markup coming from rich text
// (FAQ blocks) or re-rendered via innerHTML can still exist before or after this runs, so
// querying once up front is not reliable. Delegation works regardless of load order.
document.addEventListener('click', function (event) {
  const openTrigger = event.target.closest(
    '[data-open-replica-warning-modal], [href="#open-replica-warning-modal"]'
  );
  if (openTrigger) {
    event.preventDefault();
    const overlay = document.querySelector('[data-replica-warning-modal-overlay]');
    if (overlay) overlay.style.display = 'flex';
    // Same convention as the theme's other modals/overlays (e.g. assets/app.js) for locking
    // background scroll while a full-screen overlay is open.
    document.body.classList.add('overflow-hidden');
    return;
  }

  const closeTrigger = event.target.closest('[data-close-replica-warning-modal]');
  if (closeTrigger) {
    const overlay = document.querySelector('[data-replica-warning-modal-overlay]');
    if (overlay) overlay.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
  }
});
